import { DataTableNew } from '@/design-system/data-table-new';
import { Inline } from '@/design-system/inline/inline';
import { Stack } from '@/design-system/stack/stack';
import {
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import { InvoiceEvidenceView } from '../../../../types/entity-types';
import {
  DATE_PAID_COLUMN_ID,
  INVOICE_INFO_COLUMN_ID,
  paidInvoiceTableColumnsDefinition,
} from './paid-invoice-table-columns-definition';
import { sortEvidencesByTxnFspDateNewestToOldest } from './utils/sort-evidences-by-txn-fspDate-newest-to-oldest';

const PAGE_SIZE = 20;

type PaidInvoiceTableInvoiceTableProps = {
  evidences: InvoiceEvidenceView[];
};

export const PaidInvoiceTable = ({ evidences }: PaidInvoiceTableInvoiceTableProps) => {
  const sortedEvidences = sortEvidencesByTxnFspDateNewestToOldest(evidences);

  const table = useReactTable({
    data: sortedEvidences,
    columns: paidInvoiceTableColumnsDefinition,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      sorting: [
        { id: DATE_PAID_COLUMN_ID, desc: true },
        { id: INVOICE_INFO_COLUMN_ID, desc: false },
      ],
      pagination: {
        pageSize: PAGE_SIZE,
      },
    },
  });

  return (
    <Stack space={5} align="stretch" className="pt-5">
      <DataTableNew.Table table={table} noResultsMessage="No paid invoices" />

      {table.getPageCount() > 1 && (
        <Inline justify="end">
          <DataTableNew.Pagination table={table} />
        </Inline>
      )}
    </Stack>
  );
};
